import { render, staticRenderFns } from "./GridViewSwitcher.vue?vue&type=template&id=44d8b754&scoped=true&"
import script from "./GridViewSwitcher.vue?vue&type=script&lang=js&"
export * from "./GridViewSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./GridViewSwitcher.vue?vue&type=style&index=0&id=44d8b754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d8b754",
  null
  
)

export default component.exports